import React from 'react'

const Gemini = () => {
  return (
    <div>Gemini</div>
  )
}

export default Gemini